"use strict";

angular.module("internal.exams").controller("InternalExamResults", [
    "$scope",
    "$stateParams",
    "EXResult",
    "EXSessions",
    function ($scope, $stateParams, EXResult, EXSessions) {
        $scope.loading = true;
        $scope.stations = [];

        EXResult.getbysession($stateParams.examSessionID).then(function (results) {
            results = results.records;
            $scope.results = results;
            var stationsList = [];
            results.forEach(function (result) {
                (result.attemptIndex == null || result.attemptIndex == 0) ? result.attemptIndex = 1 : result.attemptIndex = result.attemptIndex + 1;
                if (result.examSessionStationName != null && !stationsList.includes(result.examSessionStationName)) {
                    stationsList.push(result.examSessionStationName);
                    $scope.stations.push({ name: result.examSessionStationName, id: result.examSessionStationName });
                }
                if (result.candidatePrimaryCertNumber != null) {
                    result.candidateName += ' (' + result.candidatePrimaryCertNumber + ')';
                }

            });
            $scope.loading = false;
        });

        EXSessions.getsessionsummary($stateParams.examSessionID).then(function (sessionSummary) {
            $scope.sessionSummary = sessionSummary;
        });

        $scope.columns = [
            {
                label: "Candidate",
                field: "candidateName",
                cfurl: 'license/users/summary.cfm?userID=',
                cfparam: 'candidateUserId'
            },
            {
                label: "Station",
                field: "examSessionStationName"
            },
            {
                label: "Form",
                field: "examFormName",
                documentid: 'documentID',
                documentcode: 'documentCode'
            },
            {
                label: "Examiner",
                field: "examinerName"
            },
            {
                label: "Attempt Number",
                field: "attemptIndex"
            },
            {
                label: "Attempt Date",
                field: "startDateTimeUtc",
                type: "datetime"
            },
            {
                label: "Attempt Status",
                field: "passed",
                type: "passfail"
            }
        ];

        $scope.filters = [
            {
                name: "Station",
                field: "examSessionStationName",
                options: $scope.stations
            },
            {
                name: "Attempt Number",
                field: "attemptIndex",
                options: [
                    { name: "1", id: 1 },
                    { name: "2", id: 2 },
                    { name: "3", id: 3 },
                    { name: "4", id: 4 },
                    { name: "5", id: 5 },
                    { name: "6", id: 6 }
                ]
            },
            {
                name: "Attempt Status",
                field: "passed",
                options: [
                    { name: "Pass", id: true },
                    { name: "Fail", id: false }
                ]
            }
        ];

    }
]);
